import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor } from '@mui/material/Alert';

interface PrimarySnackProps {
  open: boolean,
  handleClose: () => void,
  message: string,
  severity: AlertColor,
}
export default function PrimarySnackbar({
  open, handleClose, message, severity,
}: PrimarySnackProps) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{ mb: open ? 3 : 0 }}
    >
      <MuiAlert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </MuiAlert>
    </Snackbar>
  );
}
